var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAltersverifizierungIdShot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 133,
    viewBox: "0 0 226 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_7609)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_707_7609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 226,
    height: 133
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44531 0.5H221.976C223.909 0.5 225.476 2.067 225.476 4V128.8C225.476 130.733 223.909 132.3 221.976 132.3H4.44531C2.51232 132.3 0.945312 130.733 0.945312 128.8V4C0.945312 2.067 2.51232 0.5 4.44531 0.5Z",
    fill: "white",
    stroke: "#AAAAAA"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_707_7609)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3576 124.702L67.3592 148.976C58.7826 150.831 54.4944 149.306 54.4944 144.4C54.4944 139.494 57.4944 126.828 63.4944 106.4L84.3732 111.426L78.3576 124.702Z",
    fill: "#F5F6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.214 57.093C151.214 75.2712 134.405 72.5217 113.671 72.5217C92.9362 72.5217 76.1276 75.2712 76.1276 57.093C76.1276 38.9149 84.3381 6.69275 113.671 6.69275C144.014 6.69275 151.214 38.9149 151.214 57.093Z",
    fill: "#687289"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.559 120.798L171.927 129.349V188.302C171.933 190.908 171.258 193.471 169.97 195.737L156.225 171.639L151.273 121.17L150.039 108.565L168.664 108.958L170.559 120.798Z",
    fill: "#F5F6F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.927 118.722C171.266 116.574 170.146 112.944 168.86 108.896C166.598 101.765 163.831 93.3224 162.189 89.3C159.054 81.6217 143.083 84.6992 143.083 84.6992L88.3646 82.6493C88.3646 82.6493 86.325 82.3808 77.1493 81.1622C73.3024 80.651 69.9512 86.0417 67.3591 92.4808L61.4944 110.4L80.108 113.719C79.0826 117.295 78.4948 120.983 78.3576 124.702C78.213 129.788 79.1115 135.473 82.9893 139C91.3492 146.621 94.0394 180.928 94.0394 180.928L88.1581 203.4H156.829C160.833 203.4 164.674 201.81 167.506 198.978C170.337 196.147 171.927 192.306 171.927 188.302V179.978C167.595 172.966 164.037 169.439 164.037 169.439L151.753 121.123L170.559 120.798L171.927 120.772V118.722Z",
    fill: "#D8DAE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.186 63.2535C143.052 53.3877 143.052 37.3921 133.186 27.5263C123.321 17.6605 107.325 17.6605 97.4593 27.5263C87.5935 37.3921 87.5935 53.3877 97.4593 63.2535C107.325 73.1192 123.321 73.1192 133.186 63.2535Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3562 44.7501H94.3482L98.7563 32.4071L99.6377 44.7501H104.413L106.985 37.55L107.499 44.7501H142.985C142.985 29.9803 131.012 18.0071 116.242 18.0071H111.099C96.3294 18.0071 84.3562 29.9803 84.3562 44.7501Z",
    fill: "#687289"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.078 89.9531H177.344C179.553 89.9531 181.344 91.744 181.344 93.9531V114.963C181.344 117.172 179.553 118.963 177.344 118.963H136.078C133.869 118.963 132.078 117.172 132.078 114.963V93.9531C132.078 91.744 133.869 89.9531 136.078 89.9531Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_707_7609",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 96,
    width: 17,
    height: 17
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.065 112.586C147.484 112.586 151.067 109.003 151.067 104.583C151.067 100.163 147.484 96.5803 143.065 96.5803C138.645 96.5803 135.062 100.163 135.062 104.583C135.062 109.003 138.645 112.586 143.065 112.586Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_707_7609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.065 112.586C147.484 112.586 151.067 109.003 151.067 104.583C151.067 100.163 147.484 96.5803 143.065 96.5803C138.645 96.5803 135.062 100.163 135.062 104.583C135.062 109.003 138.645 112.586 143.065 112.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.065 106.354C145.067 106.354 146.691 104.731 146.691 102.728C146.691 100.725 145.067 99.1019 143.065 99.1019C141.062 99.1019 139.438 100.725 139.438 102.728C139.438 104.731 141.062 106.354 143.065 106.354Z",
    fill: "#87A0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.064 119.74C146.569 119.74 149.41 116.899 149.41 113.394C149.41 109.889 146.569 107.048 143.064 107.048C139.56 107.048 136.719 109.889 136.719 113.394C136.719 116.899 139.56 119.74 143.064 119.74Z",
    fill: "#87A0AE"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.466 95.455H156.461C155.839 95.455 155.335 95.9588 155.335 96.5803C155.335 97.2018 155.839 97.7057 156.461 97.7057H172.466C173.087 97.7057 173.591 97.2018 173.591 96.5803C173.591 95.9588 173.087 95.455 172.466 95.455Z",
    fill: "#DBE5EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.379 107.602H155.978C155.623 107.602 155.335 107.89 155.335 108.245C155.335 108.6 155.623 108.888 155.978 108.888H163.379C163.734 108.888 164.022 108.6 164.022 108.245C164.022 107.89 163.734 107.602 163.379 107.602Z",
    fill: "#DBE5EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.308 107.602H167.907C167.552 107.602 167.264 107.89 167.264 108.245C167.264 108.6 167.552 108.888 167.907 108.888H175.308C175.663 108.888 175.951 108.6 175.951 108.245C175.951 107.89 175.663 107.602 175.308 107.602Z",
    fill: "#DBE5EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M176.967 99.7063H156.461C155.839 99.7063 155.335 100.21 155.335 100.832C155.335 101.453 155.839 101.957 156.461 101.957H176.967C177.589 101.957 178.093 101.453 178.093 100.832C178.093 100.21 177.589 99.7063 176.967 99.7063Z",
    fill: "#DBE5EE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M165.521 110.031H155.978C155.623 110.031 155.335 110.319 155.335 110.674C155.335 111.029 155.623 111.317 155.978 111.317H165.521C165.876 111.317 166.164 111.029 166.164 110.674C166.164 110.319 165.876 110.031 165.521 110.031Z",
    fill: "#DBE5EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M177.45 110.031H167.907C167.552 110.031 167.264 110.319 167.264 110.674C167.264 111.029 167.552 111.317 167.907 111.317H177.45C177.805 111.317 178.093 111.029 178.093 110.674C178.093 110.319 177.805 110.031 177.45 110.031Z",
    fill: "#DBE5EE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.976 0H4.44531C2.23617 0 0.445312 1.79086 0.445312 4V128.8C0.445312 131.009 2.23617 132.8 4.44531 132.8H221.976C224.185 132.8 225.976 131.009 225.976 128.8V4C225.976 1.79086 224.185 0 221.976 0Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.6,
    strokeDasharray: "4 4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_7609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225.531,
    height: 132.8,
    fill: "white",
    transform: "translate(0.445312)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAltersverifizierungIdShot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/altersverifizierung-id-shot.b004f22d3ba031b36ffad168eafd0dd2.svg";